/**
 * @flow
 * @relayHash f04ecd3b1300c349231885d61d0a46a4
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type PaginatedLotsContainer_lots$ref = any;
export type LotSortField = "BIN_NUMBER" | "CREATED_AT" | "EXPIRES_AT" | "LOT_NUMBER" | "UPDATED_AT";
export type Permission = "CREATE_API_KEY" | "CREATE_CUSTOMER" | "CREATE_INVOICE" | "CREATE_ITEM" | "CREATE_JOB" | "CREATE_LOT" | "CREATE_ORDER" | "CREATE_PAYMENT" | "CREATE_SHIPMENT" | "DELETE_API_KEY" | "DELETE_CUSTOMER" | "DELETE_INVOICE" | "DELETE_ITEM" | "DELETE_JOB" | "DELETE_LOT" | "DELETE_ORDER" | "DELETE_SHIPMENT" | "READ_API_KEY" | "READ_CUSTOMER" | "READ_INVOICE" | "READ_ITEM" | "READ_JOB" | "READ_LOT" | "READ_ORDER" | "READ_PAYMENT" | "READ_SHIPMENT" | "UPDATE_API_KEY" | "UPDATE_CUSTOMER" | "UPDATE_INVOICE" | "UPDATE_ITEM" | "UPDATE_JOB" | "UPDATE_LOT" | "UPDATE_ORDER" | "UPDATE_SHIPMENT";
export type SortDirection = "ASC" | "DESC";
export type LotSort = {|
  field: LotSortField,
  direction: SortDirection,
|};
export type LotsQueryVariables = {|
  count: number,
  search?: ?string,
  sortBy?: ?LotSort,
  cursor?: ?string,
  lotNumbers?: ?$ReadOnlyArray<string>,
  binNumbers?: ?$ReadOnlyArray<string>,
|};
export type LotsQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +permissions: $ReadOnlyArray<Permission>,
  |},
  +$fragmentRefs: PaginatedLotsContainer_lots$ref,
|};
export type LotsQuery = {|
  variables: LotsQueryVariables,
  response: LotsQueryResponse,
|};
*/


/*
query LotsQuery(
  $search: String
  $sortBy: LotSort
  $lotNumbers: [String!]
  $binNumbers: [String!]
) {
  ...PaginatedLotsContainer_lots_Wl51m
  viewer {
    id
    permissions
  }
}

fragment PaginatedLotsContainer_lots_Wl51m on Query {
  lots(first: 30, search: $search, sortBy: $sortBy, lotNumbers: $lotNumbers, binNumbers: $binNumbers) {
    edges {
      cursor
      ...LotsTable_lotEdges
      node {
        __typename
        id
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment LotsTable_lotEdges on LotEdge {
  node {
    id
    lotNumber
    binNumber
    quantity
    expiresAt
    ...AddUpdateLotModal_lot
  }
}

fragment AddUpdateLotModal_lot on Lot {
  id
  lotNumber
  binNumber
  expiresAt
  warehouseLocation {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "LotSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "cursor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "lotNumbers",
    "type": "[String!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "binNumbers",
    "type": "[String!]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "viewer",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "permissions",
      "args": null,
      "storageKey": null
    }
  ]
},
v3 = {
  "kind": "Variable",
  "name": "binNumbers",
  "variableName": "binNumbers"
},
v4 = {
  "kind": "Variable",
  "name": "lotNumbers",
  "variableName": "lotNumbers"
},
v5 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v6 = {
  "kind": "Variable",
  "name": "sortBy",
  "variableName": "sortBy"
},
v7 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 30
  },
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LotsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      (v2/*: any*/),
      {
        "kind": "FragmentSpread",
        "name": "PaginatedLotsContainer_lots",
        "args": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "LotsQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "lots",
        "storageKey": null,
        "args": (v7/*: any*/),
        "concreteType": "LotConnection",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "LotEdge",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "cursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "Lot",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lotNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "binNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "quantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "expiresAt",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "warehouseLocation",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WarehouseLocation",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pageInfo",
            "storageKey": null,
            "args": null,
            "concreteType": "PageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endCursor",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "hasNextPage",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedHandle",
        "alias": null,
        "name": "lots",
        "args": (v7/*: any*/),
        "handle": "connection",
        "key": "PaginatedLotsContainer_lots",
        "filters": []
      },
      (v2/*: any*/)
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "LotsQuery",
    "id": null,
    "text": "query LotsQuery(\n  $search: String\n  $sortBy: LotSort\n  $lotNumbers: [String!]\n  $binNumbers: [String!]\n) {\n  ...PaginatedLotsContainer_lots_Wl51m\n  viewer {\n    id\n    permissions\n  }\n}\n\nfragment PaginatedLotsContainer_lots_Wl51m on Query {\n  lots(first: 30, search: $search, sortBy: $sortBy, lotNumbers: $lotNumbers, binNumbers: $binNumbers) {\n    edges {\n      cursor\n      ...LotsTable_lotEdges\n      node {\n        __typename\n        id\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment LotsTable_lotEdges on LotEdge {\n  node {\n    id\n    lotNumber\n    binNumber\n    quantity\n    expiresAt\n    ...AddUpdateLotModal_lot\n  }\n}\n\nfragment AddUpdateLotModal_lot on Lot {\n  id\n  lotNumber\n  binNumber\n  expiresAt\n  warehouseLocation {\n    id\n    name\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'c4b650fe02e0625e59969054bba254ea';
module.exports = node;
